import { render, staticRenderFns } from "./CategoryEditorDialog.vue?vue&type=template&id=482fd08f&"
import script from "./CategoryEditorDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports